module.exports = __webpack_public_path__ + "img/yogesh_landing.a39a6b19.png";